import { Component, OnInit } from '@angular/core';
import { LoggerService } from 'src/app/services';
import { OrganisationInvoiceReportService } from 'src/app/services';
import { TaggedLogger } from 'src/app/services/taggedLogger';
import { Message, MessageService } from 'primeng/api';

@Component({
  selector: 'app-customer-invoice-report',
  templateUrl: './customer-invoice-report.component.html',
  styleUrls: ['./customer-invoice-report.component.css'],
})
export class CustomerInvoiceReportComponent implements OnInit {
  customerorgId: number = null;
  readonly logger: TaggedLogger;
  customerInvoiceReportSetting: any[] = null;
  isVmeMode: boolean = true;
  isLoading: boolean = false;
  constructor(
    private organisationInvoiceReportService: OrganisationInvoiceReportService,
    private loggerService: LoggerService,
    private messageService: MessageService,
  ) {
    this.logger = loggerService.taggedLogger('component:customer-invoice-report');
  }

  ngOnInit() {}

  onOrganisationChange(orgId: number) {
    if (orgId) {
      this.customerorgId = orgId;
      this.isLoading = true;
      // get the organisation invoice settings
      this.organisationInvoiceReportService
        .getCustomerReportSettings(orgId)
        .then((res) => {
          this.customerInvoiceReportSetting = res;
          this.isLoading = false;
        })
        .catch((err) => {
          this.logger.error(err);
          this.isLoading = false;
        });
    } else {
      this.customerInvoiceReportSetting = null;
      this.customerorgId = orgId = null;
    }
  }

  saveSettings() {
    this.organisationInvoiceReportService
      .saveCustomerReportSettings(this.customerInvoiceReportSetting)
      .then((res) => {})
      .catch((err) => {
        this.logger.error(err);
      });
  }
}
